import { render, staticRenderFns } from "./pickPackShipStep3.vue?vue&type=template&id=6ef52942&scoped=true"
import script from "./pickPackShipStep3.vue?vue&type=script&lang=js"
export * from "./pickPackShipStep3.vue?vue&type=script&lang=js"
import style0 from "./pickPackShipStep3.vue?vue&type=style&index=0&id=6ef52942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef52942",
  null
  
)

export default component.exports